module.exports = __webpack_public_path__ + "img/3-(3).f5c11ce1.jpg";